const getters = {
  sidebar: state => state.app.sidebar,
  visitedViews: state => state.app.visitedViews,
  name: state => state.user.name,
  permission_routers: state => state.permission.routers,
  current_routers: state => state.permission.current_routers,
  tools_app: state => state.app.tools_app,
  appType: state => state.app.appType,
  addRouters: state => state.permission.addRouters
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js